import { useEffect, useRef } from "react";
import { connect } from "react-redux";
import DocumentMeta from "react-document-meta";
import { withRouter, Link } from "react-router-dom";
import IntroCohort from "./components/IntroCohort/IntroCohort";
import ActiveProgram from "./components/ActiveProgram/ActiveProgram";
import HowToHost from "./components/HowToHost/HowToHost";

import { getCohartData } from "./dependencies/action";

import { initGA, logPageView } from "../../analytics";
import { PRODUCTION_MOVE_HIDDEN } from "../common/constants/actionConstants";

const CohortProgram = (props) => {
  const pushbtnviewcohort = useRef();
  // const data = props.history.location.state

  // if (
  //   props.location.state?.fromPage &&
  //   props.location.state?.fromPage === "mentorDashboard"
  // ) {

  //   pushbtnviewcohort?.current && pushbtnviewcohort?.current.click();
  // }
  // useEffect(() => {
  //   const frompagevariable = props.location.state?.fromPage;

  //   if (frompagevariable && frompagevariable === "mentorDashboard") {
  //     pushbtnviewcohort?.current && pushbtnviewcohort?.current.click();
  //   } else {
  //   }

  // }, []);

  useEffect(() => {
    // const frompagevariable = props.location.state?.fromPage;

    // if (frompagevariable && frompagevariable === "mentorDashboard") {
    //   pushbtnviewcohort?.current && pushbtnviewcohort?.current.click();
    // } else {
    // }

    // to call the initialise google analytics funtion
    try {
      initGA();
      window.GA_INITIALIZED = true;
      // to save the number og visitors on this side
      logPageView();
    } catch (error) {}
  }, [window]);

  const { getCohartData, currentInterventionList } = props;
  useEffect(() => {
    getCohartData(localStorage.getItem("SelectedLang"));
  }, [getCohartData]);

  const Banner = currentInterventionList?.Banner;
  const HowtoHostaCohortProgram =
    currentInterventionList?.HowtoHostaCohortProgram;
  const meta = {
    title: "MAARG",
    description: "",
    canonical: "https://maarg.startupindia.gov.in/",
    meta: {
      charset: "utf-8",
      name: {
        keywords: "Mentorship,startupindia,startup, mentor, Mentor , Startup",
      },
    },
  };
  return (
    <DocumentMeta {...meta}>
      <div style={{ marginTop: "50px" }}>
        {currentInterventionList ? (
          <>
            <IntroCohort
              data={Banner}
              pushbtnviewcohort={pushbtnviewcohort}
              fromPage={props.history.location.state?.fromPage}
            />
            {PRODUCTION_MOVE_HIDDEN ? (
              ""
            ) : (
              <>
                <ActiveProgram
                  data={HowtoHostaCohortProgram}
                  // pushbtnviewcohort={pushbtnviewcohort}
                  // fromPage={props.history.location.state?.fromPage}
                />
              </>
            )}

            <HowToHost data={HowtoHostaCohortProgram} />
          </>
        ) : null}
      </div>
    </DocumentMeta>
  );
};
const mapStateToProps = (state) => {
  return {
    currentInterventionList: state.CohartReducer.currentInerventionList.list,
  };
};
export default connect(mapStateToProps, { getCohartData })(
  withRouter(CohortProgram)
);
